export default {
  register_as: "{{- date}}からインフルエンサーとして登録",
  edit_profile: "プロフィール編集",
  rating_from_admin: "インフルエンサーとしての募集案件主からの評価",
  sns_activity: "インフルエンサー活動SNS",
  self_introduction: "インフルエンサーとしての自己紹介（得意分野コメント）",
  cancel_change_confirm: "変更内容をキャンセルしますか？",
  upload_avatar: "顔写真を変更",
};
